<script setup lang="ts">
import BaseButton from './BaseButton.vue';

interface Props {
  size?: 'small' | 'large';
  htmlType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  htmlType: 'button',
  loading: false,
  disabled: false,
  block: false,
});
</script>

<template>
  <BaseButton v-bind="props" type="default" class="button-outlined">
    <slot></slot>
    <template v-for="slotName in Object.keys($slots)" #[slotName]>
      <slot :name="slotName"></slot>
    </template>
  </BaseButton>
</template>

<style lang="less" scoped>
.button-outlined {
  background-color: white;
  border-color: @color-primary;
  border-width: 1.5px;
  color: @color-primary;

  // repeating attrs to overwrite antdv
  &:hover,
  &:active {
    background-color: @color-background-light;
    border-color: @color-primary;
    color: @color-primary;
  }

  &:focus {
    background-color: white;
    border-color: @color-primary;
    border-width: 2.5px;
    color: @color-primary;
  }
}
</style>
